/**
 * Application-wide constants
 */

/**
 * Regular expression pattern for validating email addresses
 * Validates standard email format: username@domain.extension
 */
export const EMAIL_PATTERN = '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$';

export enum EnumNavigation {
  DASHBOARD_HOME = 'dashboard',
  CHAT_HOME = 'dashboard/chat',
  SETTINGS_HOME = 'dashboard/settings',
  PROFILES_HOME = 'dashboard/profile',
  CONTACTS_HOME = 'contacts',
  LOCATIONS_HOME = 'locations',
  ACTIVITY_HOME = 'activity',
  ENRICHMENT_HOME = 'enrichment',
}
